   function test() {
     const selectedCategory = document.querySelector('input[name="category"]:checked');

  if (selectedCategory) {
    const categoryValue = selectedCategory.value;
    const searchParams = new URLSearchParams(window.location.search);

    // Kategori filtresini güncelle
    searchParams.set("filter.p.t.category", categoryValue);

      // Yeni URL oluştur ve yönlendir
      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      window.location.href = newUrl;
    }
     checkCustom()
   }

const legacySortSelect = document.getElementById('sortBy');
if (legacySortSelect) {
  legacySortSelect.addEventListener('change', function() {
    const selectedValue = this.value;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', selectedValue);
    window.location.href = url.href;
  });
}
  function toggleSelect() {
  const select = document.getElementById('sortBy');
  const isVisible = select.classList.contains('hidden');
  select.classList.toggle('hidden', !isVisible);
} 
